import client from './client';
import type { Page } from '@dtwin/shared';

export async function fetchPages(): Promise<Page[]> {
  const { data } = await client.get('/pages');
  return data;
}

export async function fetchPage(id: string): Promise<Page> {
  const { data } = await client.get(`/pages/${id}`);
  return data;
}

export async function createPage(body: {
  id?: string;
  name: string;
  description?: string;
  sceneId?: string;
  thumbnail?: string;
  sceneAnchor?: Page['sceneAnchor'];
  config?: Page['config'];
}): Promise<Page> {
  const { data } = await client.post('/pages', body);
  return data;
}

export async function updatePage(id: string, body: Partial<Page>): Promise<Page> {
  const { data } = await client.put(`/pages/${id}`, body);
  return data;
}

export async function deletePage(id: string): Promise<void> {
  await client.delete(`/pages/${id}`);
}

export async function fetchTrashPages(): Promise<any[]> {
  const { data } = await client.get('/pages/trash');
  return data;
}

export async function restorePage(id: string): Promise<any> {
  const { data } = await client.post(`/pages/${id}/restore`);
  return data;
}

export async function permanentDeletePage(id: string): Promise<void> {
  await client.delete(`/pages/${id}/permanent`);
}

export async function updatePageComponents(id: string, components: any[]): Promise<any[]> {
  const { data } = await client.put(`/pages/${id}/components`, components);
  return data;
}
